import React from "react";

class DigitalAdvantage extends React.Component {
  render() {
    return (
      <>
        <div className="section-full p-t80 p-b80 bg-gray">
          <div className="container">
            {/* Section Header */}
            <div className="section-head text-center">
              <h2
                className="text-uppercase m-b15"
                style={{
                  color: "rgb(63, 164, 202)",
                  fontSize: "36px",
                  fontWeight: "600",
                }}
              >
                Digital Advantage
              </h2>
              <div className="mt-separator-outer">
                <div className="mt-separator bg-primary"></div>
              </div>
              <p
                className="m-t20"
                style={{
                  color: "#666",
                  fontSize: "18px",
                  maxWidth: "600px",
                  margin: "20px auto 0",
                }}
              >
                Know your delivery status, payment history, and credit—with our
                all in one digital platform
              </p>
            </div>

            {/* Features Grid */}
            <div className="section-content m-t50">
              <div className="row">
                {/* Quick Access */}
                <div className="col-lg-3 col-md-6 col-sm-6 m-b30">
                  <div
                    className="mt-icon-box-wraper center p-a30 bg-white"
                    style={{
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                      border: "1px solid #f0f0f0",
                      height: "220px",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    }}
                  >
                    <div
                      className="mt-icon-box-lg radius bg-primary m-b20"
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "12px",
                        backgroundColor: "#f8f9ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 20px",
                      }}
                    >
                      <div
                        style={{
                          width: "60px",
                          height: "45px",
                          backgroundImage:
                            "linear-gradient(135deg, rgb(63, 164, 202) 0%, rgb(83, 184, 222) 100%)",
                          borderRadius: "8px",
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <i
                          className="fa fa-laptop"
                          style={{ color: "white", fontSize: "24px" }}
                        ></i>
                        <div
                          style={{
                            position: "absolute",
                            bottom: "-10px",
                            right: "-5px",
                            width: "20px",
                            height: "15px",
                            backgroundColor: "#ff6b6b",
                            borderRadius: "3px",
                            border: "2px solid white",
                          }}
                        ></div>
                      </div>
                    </div>
                    <div className="mt-icon-box-info">
                      <h4
                        className="mt-tilte"
                        style={{
                          fontSize: "20px",
                          fontWeight: "600",
                          color: "#333",
                          marginBottom: "10px",
                        }}
                      >
                        Top Brand
                      </h4>
                      <p
                        style={{
                          color: "#666",
                          fontSize: "14px",
                          lineHeight: "1.6",
                        }}
                      >
                        All brand at one Roof
                      </p>
                    </div>
                  </div>
                </div>

                {/* Real-Time Insights */}
                <div className="col-lg-3 col-md-6 col-sm-6 m-b30">
                  <div
                    className="mt-icon-box-wraper center p-a30 bg-white"
                    style={{
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                      border: "1px solid #f0f0f0",
                      height: "220px",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    }}
                  >
                    <div
                      className="mt-icon-box-lg radius bg-primary m-b20"
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "12px",
                        backgroundColor: "#f8f9ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 20px",
                      }}
                    >
                      <div
                        style={{
                          width: "60px",
                          height: "45px",
                          backgroundImage:
                            "linear-gradient(135deg, rgb(63, 164, 202) 0%, rgb(83, 184, 222) 100%)",
                          borderRadius: "8px",
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <i
                          className="fa fa-search"
                          style={{ color: "white", fontSize: "20px" }}
                        ></i>
                        <div
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",
                            width: "16px",
                            height: "16px",
                            backgroundColor: "#4CAF50",
                            borderRadius: "50%",
                            border: "2px solid white",
                          }}
                        ></div>
                      </div>
                    </div>
                    <div className="mt-icon-box-info">
                      <h4
                        className="mt-tilte"
                        style={{
                          fontSize: "20px",
                          fontWeight: "600",
                          color: "#333",
                          marginBottom: "10px",
                        }}
                      >
                        Real-Time Insights
                      </h4>
                      <p
                        style={{
                          color: "#666",
                          fontSize: "14px",
                          lineHeight: "1.6",
                        }}
                      >
                        at every step.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Smart Tracking */}
                <div className="col-lg-3 col-md-6 col-sm-6 m-b30">
                  <div
                    className="mt-icon-box-wraper center p-a30 bg-white"
                    style={{
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                      border: "1px solid #f0f0f0",
                      height: "220px",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    }}
                  >
                    <div
                      className="mt-icon-box-lg radius bg-primary m-b20"
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "12px",
                        backgroundColor: "#f8f9ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 20px",
                      }}
                    >
                      <div
                        style={{
                          width: "60px",
                          height: "45px",
                          backgroundImage:
                            "linear-gradient(135deg, rgb(63, 164, 202) 0%, rgb(83, 184, 222) 100%)",
                          borderRadius: "8px",
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <i
                          className="fa fa-shield"
                          style={{ color: "white", fontSize: "20px" }}
                        ></i>
                        <div
                          style={{
                            position: "absolute",
                            bottom: "-8px",
                            right: "-8px",
                            width: "24px",
                            height: "18px",
                            backgroundColor: "rgb(63, 164, 202)",
                            borderRadius: "4px",
                            border: "2px solid white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <i
                            className="fa fa-map-marker"
                            style={{ color: "white", fontSize: "10px" }}
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div className="mt-icon-box-info">
                      <h4
                        className="mt-tilte"
                        style={{
                          fontSize: "20px",
                          fontWeight: "600",
                          color: "#333",
                          marginBottom: "10px",
                        }}
                      >
                        Smart Tracking
                      </h4>
                      <p
                        style={{
                          color: "#666",
                          fontSize: "14px",
                          lineHeight: "1.6",
                        }}
                      >
                        from dispatch to delivery
                      </p>
                    </div>
                  </div>
                </div>

                {/* Instant Support */}
                <div className="col-lg-3 col-md-6 col-sm-6 m-b30">
                  <div
                    className="mt-icon-box-wraper center p-a30 bg-white"
                    style={{
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                      border: "1px solid #f0f0f0",
                      height: "220px",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    }}
                  >
                    <div
                      className="mt-icon-box-lg radius bg-primary m-b20"
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "12px",
                        backgroundColor: "#f8f9ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 20px",
                      }}
                    >
                      <div
                        style={{
                          width: "60px",
                          height: "45px",
                          backgroundImage:
                            "linear-gradient(135deg, rgb(63, 164, 202) 0%, rgb(83, 184, 222) 100%)",
                          borderRadius: "8px",
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <i
                          className="fa fa-comments"
                          style={{ color: "white", fontSize: "20px" }}
                        ></i>
                        <div
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",
                            width: "20px",
                            height: "15px",
                            backgroundColor: "#ff6b6b",
                            borderRadius: "3px",
                            border: "2px solid white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <span
                            style={{
                              color: "white",
                              fontSize: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            !
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="mt-icon-box-info">
                      <h4
                        className="mt-tilte"
                        style={{
                          fontSize: "20px",
                          fontWeight: "600",
                          color: "#333",
                          marginBottom: "10px",
                        }}
                      >
                        Instant Support,
                      </h4>
                      <p
                        style={{
                          color: "#666",
                          fontSize: "14px",
                          lineHeight: "1.6",
                        }}
                      >
                        no delays, no hassle
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add hover effects via CSS-in-JS */}
        <style jsx>{`
                    .mt-icon-box-wraper:hover {
                        transform: translateY(-5px) !important;
                        box-shadow: 0 8px 30px rgba(0,0,0,0.12) !important;
                    }

                    @media (max-width: 991px) {
                        .col-lg-3 {
                            margin-bottom: 30px;
                        }
                    }

                    @media (max-width: 767px) {
                        .section-head h2 {
                            font-size: 28px !important;
                        }
                        
                        .mt-icon-box-wraper {
                            height: auto !important;
                            min-height: 280px;
                        }
                        
                        .section-head p {
                            font-size: 16px !important;
                            padding: 0 15px;
                        }
                    }

                    @media (max-width: 576px) {
                        .col-sm-6 {
                            max-width: 100%;
                            flex: 0 0 100%;
                        }
                        
                        .section-head h2 {
                            font-size: 24px !important;
                        }
                    }
                `}</style>
      </>
    );
  }
}

export default DigitalAdvantage;
